import { render, staticRenderFns } from "./ScreenTimeChart.vue?vue&type=template&id=4a901cdb&scoped=true&"
import script from "./ScreenTimeChart.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a901cdb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a901cdb')) {
      api.createRecord('4a901cdb', component.options)
    } else {
      api.reload('4a901cdb', component.options)
    }
    module.hot.accept("./ScreenTimeChart.vue?vue&type=template&id=4a901cdb&scoped=true&", function () {
      api.rerender('4a901cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Charts/ScreenTimeChart.vue"
export default component.exports